const API_BASE_URL = process.env.REACT_APP_API_URL;

const getAuthToken = () => {
  return (
    localStorage.getItem("accessToken") ||
    sessionStorage.getItem("accessToken")
  );
};

const fetchWithAuth = async (url, options = {}) => {
  const token = getAuthToken();

  const headers = {
    "Content-Type": "application/json",
    ...(options.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };

  const response = await fetch(API_BASE_URL + url, {
    ...options,
    headers,
  });

  if (!response.ok) {
    let error = {};
    try {
      error = await response.json();
    } catch (e) {}
    // Check for 401 or Invalid Token
    if (
      response.status === 401 ||
      error.message === 'Invalid Token' ||
      error.message === 'Unauthorized' ||
      error.message === 'Access Denied'
    ) {
      // Clear user data but don't reload - let the component handle the error
      localStorage.removeItem('user');
      localStorage.removeItem('accessToken');
      sessionStorage.removeItem('user');
      sessionStorage.removeItem('accessToken');
      
      // Dispatch custom event to trigger login modal
      window.dispatchEvent(new CustomEvent('authError', { 
        detail: { message: error.message || 'Invalid Token' || 'Access Denied' } 
      }));
    }
    throw new Error(error.message || `Request failed with status ${response.status}`);
  }

  return response.json();
};

const apiClient = {
  get: (url, options = {}) => {
    let fullUrl = url;
    if (options.params) {
      const searchParams = new URLSearchParams();
      Object.entries(options.params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          searchParams.append(key, value);
        }
      });
      const queryString = searchParams.toString();
      if (queryString) {
        fullUrl += `?${queryString}`;
      }
    }
    return fetchWithAuth(fullUrl);
  },
  post: (url, body) => fetchWithAuth(url, { method: "POST", body: JSON.stringify(body) }),
  put: (url, body) => fetchWithAuth(url, { method: "PUT", body: JSON.stringify(body) }),
  delete: (url) => fetchWithAuth(url, { method: "DELETE" }),
};

export default apiClient;
